import { render } from "./BloqueCincoPrincipal.vue?vue&type=template&id=3093bafb"
import script from "./BloqueCincoPrincipal.vue?vue&type=script&lang=js"
export * from "./BloqueCincoPrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__